module.exports = __webpack_public_path__ + "img/mulitiple.cdefbf78.png";